<ng-container *t="let t">
    <div>
        <div class="people internal-container">
            <tsl-tab-group [selectedIndex]="defaultTabIndex" (selectedTabChange)="onChangePurpose($event)">
                <ng-container *ngFor="let purpose of addressPurpose">
                    <tsl-tab [label]="purpose.name" *ngIf="purpose.name !== 'Off-Site Part Storage Locations'">
                        <ng-template tsl-tab-label>
                            <div i18n>
                                {{ translateService.get(purpose.name) }}</div>
                            <a target="_blank" *ngIf="purpose.name==='RemitTo'" [href]="helpUrl">
                                <tsl-icon size="small" class="header-help-icon">help</tsl-icon>
                            </a>
                        </ng-template>
                        <!-- <div class="internal-container">
                        <ng-container [ngTemplateOutlet]="tableTpl"
                            [ngTemplateOutletContext]="{currentPageSource:currentPageSource}">
                        </ng-container>
                    </div> -->
                    </tsl-tab>
                </ng-container>
            </tsl-tab-group>
            <div fxLayoutGap="10px">
                <div>
                    <div style="float: left;">
                        <p *ngIf="showManufacturingAddressCMTUrl && filterSelection =='Manufacturing'">
                            <span i18n="@@200a43ccf0012e8a0b2ee053c8cf7a733d459452"
                                t="200a43ccf0012e8a0b2ee053c8cf7a733d459452">To create a supplier change request
                                for any
                                Manufacturing
                                addresses please create a ticket in</span>

                            <a target="_blank" [href]="manufacturingAddresscmtUrl">CMT System.</a>
                        </p>
                    </div>
                    <div class="right">
                        <button tsl-button size="small" color="black" outline
                            *ngIf="this.userDetails && tabPermissions?.address != 'NoAccess' && (filterSelection =='Manufacturing' || filterSelection=='RemitTo')"
                            (click)="showHistory();" i18n="@@bc122c6e518f00d95e8fc4c69ea553c30bec434e"
                            t="bc122c6e518f00d95e8fc4c69ea553c30bec434e" tooltip="History"
                            i18n-tooltip="@@bc122c6e518f00d95e8fc4c69ea553c30bec434e" #historyButton
                            tslTooltip="{{ t('bc122c6e518f00d95e8fc4c69ea553c30bec434e', historyButton) }}">History</button>
                        <button tsl-button size="small" color="blue"
                            *ngIf="this.userDetails && tabPermissions?.address == 'ReadWrite' && filterSelection=='RemitTo'"
                            (click)="openDialog(null)" i18n="@@81cce75e0f9b012a41d1df3e86e1a60ac87753e3"
                            t="81cce75e0f9b012a41d1df3e86e1a60ac87753e3" tooltip="Add Address"
                            i18n-tooltip="@@81cce75e0f9b012a41d1df3e86e1a60ac87753e3" #addAddressButton
                            tslTooltip="{{ t('81cce75e0f9b012a41d1df3e86e1a60ac87753e3', addAddressButton) }}">Add
                            Address</button>
                    </div>
                </div>

            </div>
            <ng-container [ngTemplateOutlet]="tableTpl">
            </ng-container>
        </div>

        <!-- add address actions-->
        <div>
            <p *ngIf="hasDraftValidationTask">
                <span style="color:red;" i18n="@@fd7bfedd95b63bb8487a05c04b3579efa8667de1"
                    t="fd7bfedd95b63bb8487a05c04b3579efa8667de1">
                    You do not have access to view this data or change functionality due to your organization’s
                    Tesla
                    Supplier Profile missing a Primary Contact. We request that you send a request inquiry to the
                    Vendor
                    Validations Team at vendorchanges@tesla.com, designating a Primary Contact for your
                    organization's
                    Tesla Supplier Profile.
                    This Primary Contact will be the main point of contact for your organization. A Primary Contact
                    is
                    responsible for adding contacts for your organization’s use of the Tesla Supplier Portal and
                    will
                    have profile standards to uphold, finance detail access, and other critical data access.
                </span>
            </p>

            <p *ngIf="hasPendingValidationTask">
                <span style="color:red;" i18n="@@4427679047587103324" t="4427679047587103324"
                    [tParams]="[primaryEmail]">
                    As the Contact Validation Task by your organization’s Primary Contact {{primaryEmail}} is still
                    pending, you currently do not have access to view this data or change functionality. In order to
                    view this data, please notify the above contact and request they log into the Tesla Supplier Portal
                    and complete the task, which can be located on the Validation Task tab on this page.
                </span>
            </p>
        </div>
        <ng-template #tableTpl>

            <!-- grid start -->
            <table tsl-table [dataSource]="currentPageSource" displayStripes="false">
                <!-- <ng-container tslColumnDef="purpose">
                    <th tsl-header-cell *tslHeaderCellDef class="columnwidth" i18n> Purpose </th>
                    <td tsl-cell *tslCellDef="let type">
                    </td>
                </ng-container> -->
                <ng-container tslColumnDef="address">
                    <th tsl-header-cell *tslHeaderCellDef class="columnwidth"
                        i18n="@@e9ded9ddc67d3d863a5484c81550ee0de9b0ff04" t="e9ded9ddc67d3d863a5484c81550ee0de9b0ff04">
                        Address </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div class="address"
                            *ngIf="element.locationName || getFullAddress(element) || getFullAddressDetails(element) || getCountryDetails(element); else empty">

                            <span class="address_title"><b>{{element.locationName}}</b></span><br>
                            <span class="address_details">
                                {{getFullAddress(element)}}<br>
                                {{getFullAddressDetails(element)}}<br>
                                {{getCountryDetails(element)}}
                            </span>

                        </div>
                    </td>
                </ng-container>

                <ng-container tslColumnDef="comment">
                    <th tsl-header-cell *tslHeaderCellDef class="comments"
                        i18n="@@a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee" t="a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee">
                        Comment </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div *ngIf="element.comment.newValue; else empty">{{ element.comment.newValue }} </div>
                    </td>
                </ng-container>

                <ng-container tslColumnDef="documents">
                    <th tsl-header-cell *tslHeaderCellDef class="documents" i18n="@@change" t="change"> Documents </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div>
                            <div *ngFor="let documentId of element.documents?.newValue">
                                <div>{{ translateService.get(getDocument(documentId)?.documentType?.newValue)}}
                                    - {{getDocument(documentId)?.fileName?.newValue}}</div>
                            </div>
                        </div>
                    </td>
                </ng-container>
                <ng-container tslColumnDef="contacts">
                    <th tsl-header-cell *tslHeaderCellDef class="contacts" i18n="@@Contacts" t="Contacts">Contacts</th>
                    <td tsl-cell *tslCellDef="let element">
                        <!-- {{element | json}} -->
                        <div *ngFor="let contact of element.contacts?.newValue">
                            <ng-container *ngIf="contact">
                                <div style="margin: 2px 0px 5px 0px;">
                                    <tsl-chip>
                                        <div *ngIf="contact?.name"
                                            style="width:300px;max-width:300px;word-wrap: break-word; margin: 0px 0px 2px 0px;">
                                            {{contact?.name}},</div>
                                        <div *ngIf="contact?.phone"
                                            style="width:300px;max-width:300px;word-wrap: break-word;margin: 0px 0px 2px 0px;">
                                            {{contact?.phone}},</div>
                                        <div *ngIf="contact?.email"
                                            style="width:300px;max-width:300px;word-wrap: break-word;margin: 0px 0px 2px 0px;">
                                            {{contact?.email}} <tsl-icon
                                                *ngIf="this.checkIfContactAlreadyExists(contact?.email)" size="small"
                                                class="header-help-icon"
                                                title="This is an existing contact in your organizations Profile Contact Tab.">
                                                info</tsl-icon>
                                        </div>
                                    </tsl-chip>
                                </div>
                            </ng-container>
                        </div>
                    </td>
                </ng-container>

                <ng-container tslColumnDef="actions">
                    <th tsl-header-cell *tslHeaderCellDef class="actions icons"
                        i18n="@@030b4423b92167200e39519599f9b863b4f7c62c" t="030b4423b92167200e39519599f9b863b4f7c62c">
                        Actions</th>
                    <td tsl-cell *tslCellDef="let element" class="actions icons">
                        <ng-container *ngIf="filterSelection !== 'Supplier Ship From Address' else suplierAction">
                            <div
                                *ngIf="element.operation.newValue || (canChangeItem(element) && element.operation?.newValue !== 'Delete') || (canChangeItem(element) && element.operation?.newValue !== 'Delete'); else empty">
                                <div *ngIf='element.operation.newValue'>
                                    <span i18n="@@a593da3ff471120f6ffc6b6f4f3e46075fb40014"
                                        t="a593da3ff471120f6ffc6b6f4f3e46075fb40014">Pending for approval - </span>
                                    {{ translateService.get(element.operation.newValue)}}
                                </div>
                                <button tsl-icon-button
                                    *ngIf="canChangeItem(element) && element.operation?.newValue !== 'Delete'"
                                    (click)="openDialog(element)">
                                    <tsl-icon status="primary">edit</tsl-icon>
                                </button>
                                <button tsl-icon-button
                                    *ngIf="canChangeItem(element) && element.operation?.newValue !== 'Delete'"
                                    (click)="deleteItem(element)">
                                    <tsl-icon status="error">delete</tsl-icon>
                                </button>
                            </div>
                        </ng-container>
                        <ng-template #suplierAction>
                            <span style="display: flex;" *ngIf="showLinkDelink">
                                <button tsl-button color="black" filled size="small" (click)="openLinkDialog(element)"
                                    i18n-title title="This action will link a contact to a specific Ship From location."
                                    outline>Link Contact</button>
                                <button tsl-button color="black" filled size="small" (click)="openUnlinkDialog(element)"
                                    i18n-title
                                    title="This action will delink a contact from a specific Ship From location."
                                    outline>Delink
                                    Contact</button>
                            </span>
                        </ng-template>

                    </td>
                </ng-container>

                <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
                <tr tsl-row *tslRowDef="let row; columns: displayedColumns;"></tr>

                <!-- Group header -->
                <ng-container tslColumnDef="groupHeader">
                    <td colspan="5" tsl-cell *tslCellDef="let group">
                        <strong class="group-header"> {{ translateService.get(group.name) }}</strong>
                    </td>
                </ng-container>
                <tr tsl-row *tslRowDef="let row; columns: ['groupHeader']; when: isAddressHeader"> </tr>
            </table>
            <!-- grid end -->
            <ng-template #empty>
                <tsl-icon>maximize</tsl-icon>
            </ng-template>
            <!-- grid pagination -->
            <tsl-pagination #paginationControl showFirstLastButtons [pageSizeOptions]="pageSizeOptions"
                showFirstLastButtons (pageChange)="pageChange($event)"
                [itemsPerPageLabel]="translateService.get('ItemsPerPage')" [total]="total"></tsl-pagination>
        </ng-template>
    </div>
</ng-container>